<script>
// Kept as a thin alias so existing imports keep working - the tooltip content
// itself now lives in a global component, so it can be reused outside of the
// profile module as well.
import InfoTooltipContent from '@/global/components/tooltips/InfoTooltipContent.vue'

export default InfoTooltipContent
</script>
